<div class="modal-header">
  <h4 class="modal-title">Filter Products</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<form [formGroup]="filterForm" (ngSubmit)="onSubmit()" style="display: contents;">
  <div class="modal-body">
    <!-- Schedule section -->
    <div class="row g-3 p-2 align-items-center">
      <div class="col-md-6">
        <label class="form-label">Schedule - Days of Week</label>
        <ng-select
          [items]="uniqueDaysOfWeek"
          bindLabel="."
          bindValue="."
          [multiple]="true"
          [closeOnSelect]="false"
          placeholder="Select weekdays..."
          formControlName="vendorDaysOfWeek">
        </ng-select>
      </div>

      <div class="col-md-6">
        <label class="form-label">Schedule - Days of Month</label>
        <ng-select
          [items]="uniqueDaysOfMonth"
          bindLabel="."
          bindValue="."
          [multiple]="true"
          [closeOnSelect]="false"
          placeholder="Select days of month..."
          formControlName="vendorDaysOfMonth">
        </ng-select>
      </div>
    </div>

    <!-- Multi-column selection row 1 -->
    <div class="row g-3 p-2">
      <!-- Vendors -->
      <div class="col-md-4">
        <div class="col-box">
          <label class="col-header">
            <input type="checkbox"
              [checked]="allVendorsSelected"
              (change)="toggleSelectAll('vendors', $event)" />
            <span>Select all Vendors</span>
          </label>
          <div class="col-search mt-2">
            <input type="text"
              class="form-control"
              placeholder="Search vendors..."
              formControlName="vendorSearch" />
          </div>
          <div class="list mt-2">
            @if (vendorsVisible.length === 0) {
              <div class="empty">No vendors</div>
            }
            @for (v of vendorsVisible; track v) {
              <div class="list-item" (click)="onToggleItem('vendors', v.id, $event)">
                <input type="checkbox"
                  [checked]="selectedVendors.includes(v.id)"
                  (change)="onToggleItem('vendors', v.id, $event)" />
                <span class="item-label">{{ v.name }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Manufacturers -->
      <div class="col-md-4">
        <div class="col-box">
          <label class="col-header">
            <input type="checkbox"
              [checked]="allManufacturersSelected"
              (change)="toggleSelectAll('manufacturers', $event)" />
            <span>Select all Manufacturers</span>
          </label>
          <div class="col-search mt-2">
            <input type="text"
              class="form-control"
              placeholder="Search manufacturers..."
              formControlName="manufacturerSearch" />
          </div>
          <div class="list mt-2">
            @if (manufacturersVisible.length === 0) {
              <div class="empty">No manufacturers</div>
            }
            @for (m of manufacturersVisible; track m) {
              <div class="list-item" (click)="onToggleItem('manufacturers', m.id, $event)">
                <input type="checkbox"
                  [checked]="selectedManufacturers.includes(m.id)"
                  (change)="onToggleItem('manufacturers', m.id, $event)" />
                <span class="item-label">{{ m.name }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Brands -->
      <div class="col-md-4">
        <div class="col-box">
          <label class="col-header">
            <input type="checkbox"
              [checked]="allBrandsSelected"
              (change)="toggleSelectAll('brands', $event)" />
            <span>Select all Brands</span>
          </label>
          <div class="col-search mt-2">
            <input type="text"
              class="form-control"
              placeholder="Search brands..."
              formControlName="brandSearch" />
          </div>
          <div class="list mt-2">
            @if (brandsVisible.length === 0) {
              <div class="empty">No brands</div>
            }
            @for (b of brandsVisible; track b) {
              <div class="list-item" (click)="onToggleItem('brands', b.id, $event)">
                <input type="checkbox"
                  [checked]="selectedBrands.includes(b.id)"
                  (change)="onToggleItem('brands', b.id, $event)" />
                <span class="item-label">{{ b.name }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Multi-column selection row 2 -->
    <div class="row g-3 p-2">
      <!-- Departments -->
      <div class="col-md-4">
        <div class="col-box">
          <label class="col-header">
            <input type="checkbox"
              [checked]="allDepartmentsSelected"
              (change)="toggleSelectAll('departments', $event)" />
            <span>Select all Departments</span>
          </label>
          <div class="col-search mt-2">
            <input type="text"
              class="form-control"
              placeholder="Search departments..."
              formControlName="departmentSearch" />
          </div>
          <div class="list mt-2">
            @if (departmentsVisible.length === 0) {
              <div class="empty">No departments</div>
            }
            @for (d of departmentsVisible; track d) {
              <div class="list-item" (click)="onToggleItem('departments', d.id, $event)">
                <input type="checkbox"
                  [checked]="selectedDepartments.includes(d.id)"
                  (change)="onToggleItem('departments', d.id, $event)" />
                <span class="item-label">{{ d.name }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Categories -->
      <div class="col-md-4">
        <div class="col-box">
          <label class="col-header">
            <input type="checkbox"
              [checked]="allCategoriesSelected"
              (change)="toggleSelectAll('categories', $event)" />
            <span>Select all Categories</span>
          </label>
          <div class="col-search mt-2">
            <input type="text"
              class="form-control"
              placeholder="Search categories..."
              formControlName="categorySearch" />
          </div>
          <div class="list mt-2">
            @if (categoriesVisible.length === 0) {
              <div class="empty">No categories</div>
            }
            @for (c of categoriesVisible; track c) {
              <div class="list-item" (click)="onToggleItem('categories', c.id, $event)">
                <input type="checkbox"
                  [checked]="selectedCategories.includes(c.id)"
                  (change)="onToggleItem('categories', c.id, $event)" />
                <span class="item-label">{{ c.name }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Sub Categories -->
      <div class="col-md-4">
        <div class="col-box">
          <label class="col-header">
            <input type="checkbox"
              [checked]="allSubCategoriesSelected"
              (change)="toggleSelectAll('subCategories', $event)" />
            <span>Select all Sub Categories</span>
          </label>
          <div class="col-search mt-2">
            <input type="text"
              class="form-control"
              placeholder="Search sub categories..."
              formControlName="subCategorySearch" />
          </div>
          <div class="list mt-2">
            @if (subCategoriesVisible.length === 0) {
              <div class="empty">No sub categories</div>
            }
            @for (s of subCategoriesVisible; track s) {
              <div class="list-item" (click)="onToggleItem('subCategories', s.id, $event)">
                <input type="checkbox"
                  [checked]="selectedSubCategories.includes(s.id)"
                  (change)="onToggleItem('subCategories', s.id, $event)" />
                <span class="item-label">{{ s.name }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary me-auto" (click)="resetSelections(); resetAllVisibles();">Reset</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
    <button type="submit" class="btn btn-primary">Apply</button>
  </div>
</form>

